module.exports = __webpack_public_path__ + "static/media/S3P4_other-considerations.01c11c37.mp3";